import { jwtDecode as jwtDecode } from 'jwt-decode';

type AuthTokenType = {
  token: string;
};

type MenuType = {
  menus: string;
};

class Storage {
  static KEYS = {
    AUTH_TOKEN: 'AUTH_TOKEN',
    MENUS: 'MENUS',
    ROLE_MASTER: 'ROLE_MASTER',
    PROFILE_INFO: 'PROFILE_INFO',
    ADMINPROFILE_INFO: 'ADMINPROFILE_INFO',
    CLASSES: 'CLASSES',
  };

  static setItem = (key: string, value: string): void => {
    if (!value) {
      value = '';
    }

    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  };

  static getItem = (key: string, shouldParse?: boolean): string | null => {
    const keyVal = localStorage.getItem(Storage.searchKey(key));

    if (shouldParse && keyVal) {
      return JSON.parse(keyVal);
    }

    return keyVal;
  };

  static searchKey(key: string): string {
    const keys = Object.keys(localStorage);
    let i = keys.length;
    while (i--) {
      try {
        if (keys[i] === key) {
          return keys[i];
        }
      } catch (e) {
        localStorage.removeItem(keys[i]);
      }
    }
    return '';
  }

  static removeItem = (key: string): void => {
    localStorage.removeItem(Storage.searchKey(key));
  };

  static clear = (): void => {
    localStorage.clear();
  };

  static getTokens = () => {
    try {
      const appAuth = Storage.getItem(Storage.KEYS.AUTH_TOKEN);
      return appAuth ? (JSON.parse(appAuth) as AuthTokenType) : null;
    } catch (e) {
      return null;
    }
  };

  static getMenus = () => {
    try {
      const appMenu = Storage.getItem(Storage.KEYS.MENUS);
      return appMenu ? (JSON.parse(appMenu) as MenuType) : [];
    } catch (e) {
      return [];
    }
  };

  static getClasses = () => {
    try {
      const appMenu = Storage.getItem(Storage.KEYS.CLASSES);
      return appMenu ? (JSON.parse(appMenu) as MenuType) : [];
    } catch (e) {
      return [];
    }
  };

  static getProfile = () => {
    try {
      const profileInfo = Storage.getItem(Storage.KEYS.PROFILE_INFO);
      return profileInfo ? (JSON.parse(profileInfo) as MenuType) : {};
    } catch (e) {
      return {};
    }
  };

  static getAdminProfile = () => {
    try {
      const adminProfile = Storage.getItem(Storage.KEYS.ADMINPROFILE_INFO);
      return adminProfile ? (JSON.parse(adminProfile) as MenuType) : {};
    } catch (e) {
      return {};
    }
  };

  static getRoleMaster = () => {
    try {
      const roleInfo = Storage.getItem(Storage.KEYS.ROLE_MASTER);
      return roleInfo ? (JSON.parse(roleInfo) as MenuType) : [];
    } catch (e) {
      return [];
    }
  };

  static isTokenValidDetails = () => {
    const tokenData: any = Storage.getTokens();
    if (!tokenData || !tokenData.token) {
      return false;
    }
    const userData: any = jwtDecode(String(tokenData.token));
    if (!userData) {
      return false;
    }
    userData.isAdmin = tokenData.isAdmin;
    userData.isClient = tokenData.isClient;
    userData.isImpersonate = tokenData?.isImpersonate ? tokenData?.isImpersonate : false;
    userData.isFromSuperAdmin = tokenData?.isFromSuperAdmin;
    userData.superUserId = tokenData?.superUserId;
    return userData;
  };

  static updateAccessToken = async (token: any) => {
    const tokenData: any = Storage.getTokens();
    tokenData.token = token;
    Storage.removeItem(Storage.KEYS.AUTH_TOKEN);
    Storage.setItem(Storage.KEYS.AUTH_TOKEN, JSON.stringify(tokenData));
    return true;
  };
}

export default Storage;
